import React from "react";
import {
  Container,
  Typography,
  Grid,
  Card,
  Avatar,
  Box,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import EmojiObjectsIcon from "@mui/icons-material/EmojiObjects";
import GroupsIcon from "@mui/icons-material/Groups";
import TrackChangesIcon from "@mui/icons-material/TrackChanges";
import PublicIcon from "@mui/icons-material/Public";
import FavoriteIcon from "@mui/icons-material/Favorite";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import { useTranslation, Trans } from "react-i18next";
import { Helmet } from "react-helmet";

const About = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t("meta_title_about")}</title>
        <meta name="description" content={t("meta_description")} />
        <link rel="alternate" hrefLang="en" href="brainstorm-visions.com/en" />
        <link rel="alternate" hrefLang="el" href="brainstorm-visions.com/el" />
      </Helmet>
      <Container sx={{ py: { xs: 4, md: 8 }, maxWidth: "md" }}>
        <Box sx={{ textAlign: "center", mb: 5 }}>
          <Avatar
            src="/logo.png"
            alt="BrainstormVisions Logo"
            sx={{
              width: { xs: 85, sm: 110, md: 120 },
              height: { xs: 85, sm: 110, md: 120 },
              mx: "auto",
              mb: 2,
              boxShadow: 4,
            }}
          />
          <Typography
            variant="h3"
            fontWeight="bold"
            gutterBottom
            color="primary"
            sx={{ fontSize: { xs: "2rem", md: "2.7rem" } }}
          >
            {t("about_title")}
          </Typography>
          <Typography variant="h6" color="text.secondary" sx={{ fontSize: { xs: "1.05rem", md: "1.23rem" } }}>
            {t("about_subtitle")}
          </Typography>
        </Box>

        <Card
          sx={{
            p: { xs: 2, md: 4 },
            mb: 5,
            borderRadius: 3,
            boxShadow: 4,
            background: "rgba(87,161,216,0.09)",
          }}
        >
          <Typography variant="h5" fontWeight="bold" gutterBottom color="secondary">
            {t("mission_title")}
          </Typography>
          <Typography paragraph>{t("mission_p1")}</Typography>
          <Typography paragraph>
            <Trans i18nKey="mission_p2" components={{ strong: <strong /> }} />
          </Typography>
          <Typography paragraph>{t("mission_p3")}</Typography>
        </Card>

        <Grid container spacing={4} mb={5}>
          <Grid item xs={12} md={6}>
            <Card sx={{ p: { xs: 2, md: 3 }, height: "100%", background: "rgba(30,41,59,0.04)" }}>
              <Typography variant="h6" fontWeight="bold" gutterBottom color="primary">
                {t("activity_title")}
              </Typography>
              <List>
                <ListItem>
                  <ListItemIcon>
                    <EmojiObjectsIcon color="secondary" />
                  </ListItemIcon>
                  <ListItemText primary={t("activity1")} secondary={t("activity1_desc")} />
                </ListItem>
                <ListItem>
                  <ListItemIcon>
                    <TrackChangesIcon color="secondary" />
                  </ListItemIcon>
                  <ListItemText primary={t("activity2")} secondary={t("activity2_desc")} />
                </ListItem>
                <ListItem>
                  <ListItemIcon>
                    <GroupsIcon color="secondary" />
                  </ListItemIcon>
                  <ListItemText primary={t("activity3")} secondary={t("activity3_desc")} />
                </ListItem>
              </List>
            </Card>
          </Grid>
          <Grid item xs={12} md={6}>
            <Card sx={{ p: { xs: 2, md: 3 }, height: "100%", background: "rgba(30,41,59,0.04)" }}>
              <Typography variant="h6" fontWeight="bold" gutterBottom color="primary">
                {t("values_title")}
              </Typography>
              <List>
                <ListItem>
                  <ListItemIcon>
                    <FavoriteIcon color="secondary" />
                  </ListItemIcon>
                  <ListItemText primary={t("value1")} />
                </ListItem>
                <ListItem>
                  <ListItemIcon>
                    <PublicIcon color="secondary" />
                  </ListItemIcon>
                  <ListItemText primary={t("value2")} />
                </ListItem>
                <ListItem>
                  <ListItemIcon>
                    <VerifiedUserIcon color="secondary" />
                  </ListItemIcon>
                  <ListItemText primary={t("value3")} />
                </ListItem>
                <ListItem>
                  <ListItemIcon>
                    <EmojiObjectsIcon color="secondary" />
                  </ListItemIcon>
                  <ListItemText primary={t("value4")} />
                </ListItem>
              </List>
            </Card>
          </Grid>
        </Grid>

        <Card sx={{ p: { xs: 2, md: 4 }, borderRadius: 3, boxShadow: 2, background: "rgba(30,41,59,0.09)" }}>
          <Typography variant="h6" fontWeight="bold" gutterBottom color="secondary">
            {t("business_identity")}
          </Typography>
          <Divider sx={{ my: 2 }} />
          <Typography fontWeight="bold">{t("company_name")}</Typography>
          <Typography>{t("company_address")}</Typography>
          <Typography>{t("company_ein")}</Typography>
        </Card>
      </Container>
    </>
  );
};

export default About;
